import EpisodeCard from './EpisodeCard';
import { Episode, EpisodeCardProps } from './types';

export default EpisodeCard;
export type { EpisodeCardProps, Episode };
